import React from 'react';
import { useLocation } from 'react-router-dom';
import styled, { keyframes, useTheme } from 'styled-components';

const sweep = keyframes`
  0% {
    transform: translateY(-100vh);
    opacity: 0;
  }
  5% {
    opacity: 0.85;
  }
  95% {
    opacity: 0.85;
  }
  100% {
    transform: translateY(100vh);
    opacity: 0;
  }
`;

const Line = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
  mix-blend-mode: screen;
  pointer-events: none;
  z-index: 4000;
  animation: ${sweep} 16s linear infinite;
`;

const GlobalScanLine: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();

  // Hide on map editor and management pages (eye strain for long use)
  if (location.pathname.includes('/map-editor/') || location.pathname.includes('/field/management')) {
    return null;
  }

  if (!theme.profile?.hud?.showGlobalScanline) {
    return null;
  }
  return <Line />;
};

export default GlobalScanLine;
